var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.91003C6 2.49582 5.66421 2.16003 5.25 2.16003C4.83579 2.16003 4.5 2.49582 4.5 2.91003V3.84753H3.75C2.92157 3.84753 2.25 4.51911 2.25 5.34753V14.3475C2.25 15.176 2.92157 15.8475 3.75 15.8475H14.25C15.0784 15.8475 15.75 15.176 15.75 14.3475V5.34753C15.75 4.51911 15.0784 3.84753 14.25 3.84753H13.5V2.91003C13.5 2.49582 13.1642 2.16003 12.75 2.16003C12.3358 2.16003 12 2.49582 12 2.91003V3.84753H6V2.91003ZM4.5 5.34753V5.91003C4.5 6.32425 4.83579 6.66003 5.25 6.66003C5.66421 6.66003 6 6.32425 6 5.91003V5.34753L12 5.34753V5.91003C12 6.32425 12.3358 6.66003 12.75 6.66003C13.1642 6.66003 13.5 6.32425 13.5 5.91003V5.34753H14.25V14.3475H3.75V5.34753H4.5ZM5.4375 8.72253C5.4375 8.30832 5.77329 7.97253 6.1875 7.97253H11.4375C11.8517 7.97253 12.1875 8.30832 12.1875 8.72253C12.1875 9.13675 11.8517 9.47253 11.4375 9.47253H6.1875C5.77329 9.47253 5.4375 9.13675 5.4375 8.72253Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduled);
export default __webpack_public_path__ + "static/media/scheduled.d2eb30e21c0e1300c8eb491932ce76b4.svg";
export { ForwardRef as ReactComponent };